/*
 *
 * File JS section Professionisti accordion
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './staff-accordion.scss';

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const staffAccordion = () => {
    let cardsProfessionista = document.querySelectorAll('.card-staff');
    if (!cardsProfessionista) return;

    let containerProfessionisti = document.querySelector(
        '.staff-accordion__container .staff-accordion__content'
    );
    let containerWidth = 0;

    const getContainerWidth = () => {
        if (containerProfessionisti) {
            containerWidth = containerProfessionisti.offsetWidth;
        }
        return containerWidth;
    };

    const closeCard = (card) => {
        // console.log(card);
        // console.log("accordion toggle " + dataAccordion);
        let dataAccordion = card.getAttribute('data-accordion');
        let accordionWrapper = card.querySelector('.card-staff__accordion');
        let accordionCardContent = card.querySelector(
            '.card-staff__accordion-content'
        );
        let accordionToToggle = card.querySelector(
            '.card-staff__accordion[data-accordion="' + dataAccordion + '"]'
        );
        containerWidth = getContainerWidth();
        let windowWidth = window.innerWidth;
        card.classList.remove('open');

        if (accordionToToggle) {
            accordionToToggle.classList.remove('open');
            accordionToToggle.style.height = '0px';
        }
        if (accordionCardContent) {
            accordionCardContent.style.visibility = 'hidden';
            accordionCardContent.style.width = 'auto';
        }
        if (accordionWrapper) {
            accordionWrapper.style.overflow = 'hidden';
            accordionWrapper.classList.remove('open');
        }
    };

    const openCard = (card) => {
        let dataAccordion = card.getAttribute('data-accordion');
        let accordionWrapper = card.querySelector('.card-staff__accordion');
        let accordionCardContent = card.querySelector(
            '.card-staff__accordion-content'
        );
        containerWidth = getContainerWidth();
        let windowWidth = window.innerWidth;

        card.classList.add('open');
        let accordionToToggle = card.querySelector(
            '.card-staff__accordion[data-accordion="' + dataAccordion + '"]'
        );

        if (accordionCardContent && windowWidth && containerWidth) {
            accordionCardContent.style.visibility = 'visible';
            accordionCardContent.style.width = containerWidth + 'px';
        }
        if (accordionWrapper) {
            accordionWrapper.style.overflow = 'visible';
        }
        let heightAccordionContent =
            accordionToToggle.querySelector('div[data-wrapper-height]')
                .offsetHeight + 50;
        if (accordionToToggle && heightAccordionContent) {
            accordionToToggle.classList.add('open');
            accordionToToggle.style.height = heightAccordionContent + 'px';
        }
    };
    const manageCard = (card) => {
        //width of container

        // console.log(heightAccordionContent);

        if (card.classList.contains('open')) {
            closeCard(card);
        } else {
            // chiudo tutte le card
            cardsProfessionista.forEach((element) => {
                closeCard(element);
                element.classList.remove('open');
            });
            openCard(card);
        }

        // card.classList.add('open');
        // accordionToOpen.classList.add('open');
        // accordionToOpen.style.height = heightAccordionContent + 'px';
        // accordionCardContent.style.visibility = 'visible'
        // accordionWrapper.style.overflow = 'visible';
        // if(windowWidth > 767) {
        //     accordionCardContent.style.width = containerWidth*0.9+'px';
        // }
    };

    cardsProfessionista.forEach((element) => {
        element.addEventListener('click', function () {
            manageCard(element);
        });
    });
};

export default staffAccordion;

//--------------------------------------------------------------------//
